'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectOption = function SelectOption(props) {
  var disabled = props.disabled,
      text = props.text,
      value = props.value;

  var optionValue = value === null ? '' : value;

  return _react2.default.createElement(
    'option',
    { value: optionValue, disabled: disabled },
    text
  );
};

SelectOption.propTypes = {
  disabled: _propTypes2.default.bool,
  text: _propTypes2.default.string,
  value: _propTypes2.default.any
};

SelectOption.defaultProps = {
  disabled: false
};

exports.default = SelectOption;